import React from "react";
import "./ProgressModal.scss";
import eventTracking from '../../utils/eventTracking';
import chapters from '../../utils/chaptersStepTranslation';

function ProgressModal(props) {
  const modal = props.modal.filter(m => m.progress === props.progress)[0];
  function onClick() {
    props.handleModal(modal.next);
    eventTracking(
      `Kapittel ${chapters[props.progress]}`,
      'Hengelås',
      'Steg 2'
    )
  }
  return (
    <>
      {modal &&
      (
        <div className="progress-modal-wrapper">
        <div className="progress-modal">
          <div className="message">{modal.text}</div>
          <div className="next" onClick={() => onClick()}>
            {modal.text2}
          </div>
        </div>
      </div>
      )}
    </>
  );
}

export default ProgressModal;
